import { Tooltip } from "@mui/material";
import ToggleButton from "../../components/ToggleButton/ToggleButton";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

function DynamicPermissionPage(props) {
  const { item } = props;
  const [IsEnabledAll, setIsEnabledAll] = useState(false);
  const [isEnable, setIsEnable] = useState([]);

  const location = useLocation();

  const handelSelectAllToggle = (e) => {
    let name = e.currentTarget.getAttribute("name");
    setIsEnabledAll(!IsEnabledAll);
    setIsEnable(item.options.map((li) => li.value));
    let object = props.inputData;
    if (IsEnabledAll) {
      setIsEnable([]);
      object[name] = [null];
      props.setInputData(object);
    } else {
      object[name] = item.options.map((li) => li.value);
      props.setInputData(object);
    }
  };

  const handelToggleClick = (e) => {
    const inputElement = e.currentTarget;
    const name = inputElement.getAttribute("name");
    const itemKey = inputElement.getAttribute("itemKey");
    const checked = inputElement.checked;
    setIsEnable([...isEnable, name]);

    let object = props.inputData;

    if (!checked) {
      setIsEnable(
          isEnable.filter((item1) => {
            return item1 !== name;
          })
      );

      if (isEnable.length === 1) {
        object[itemKey] = [null];
        return;
      }

      object[itemKey] = isEnable.filter((item1) => {
        return item1 !== name;
      });

      props.setInputData(object);
      setIsEnabledAll(false);
    } else {
      object[itemKey] = [...isEnable, name];
      props.setInputData(object);
      if (isEnable.length + 1 === item.options.length) {
        setIsEnabledAll(true);
      }
    }
  };

  useEffect(() => {
    if (location.pathname.split("/")[2] !== "create") {
      setIsEnable(props.inputData[props.item.key]);
      if (isEnable.length === item.options.length) {
        setIsEnabledAll(true);
      }
    }
  }, [isEnable.length, item, location.pathname, props]);



  return (
      <>
        <table className="border-collapse border-2 w-full mb-8">
          <tbody>
          <tr>
            <td className="border-2 border-slate-300 p-4 min-w-[180px] bg-permission_header_background">
              <div className="flex flex-col items-center gap-2 text-[#eee]">
                <label>{item.label}</label>
                <ToggleButton
                    name={item.key}
                    isEnabled={IsEnabledAll}
                    label={item.label}
                    on_click={handelSelectAllToggle}
                />
              </div>
            </td>
            {item.options.map((cellItem) => (
                <td
                    key={cellItem.value}
                    className="border-2 border-slate-300 bg-[#60a3bc] min-w-[85px]"
                >
                  <div className="flex flex-col items-center gap-2 text-[#ddd]">
                    <div>
                      <Tooltip
                          title={
                            props.item.help === undefined
                                ? ""
                                : props.item.help.body
                          }
                          placement="left-start"
                          arrow
                      >
                        <label
                            htmlFor={item.key + "-" + cellItem.value}
                            className="text-[14px]"
                        >
                          {cellItem.label}
                        </label>
                      </Tooltip>
                    </div>
                    <ToggleButton
                        id={item.key + "-" + cellItem.key}
                        itemKey={item.key}
                        name={cellItem.value}
                        isEnabled={isEnable.includes(cellItem.value)}
                        on_click={handelToggleClick}
                    />
                  </div>
                </td>
            ))}
          </tr>
          </tbody>
        </table>
      </>
  );
}

export default DynamicPermissionPage;
